import React from 'react';
import { useStyletron } from 'baseui';
import { COLOURS } from '@gtintel/platform-utils';
export const DataPills = ({
  data
}) => {
  const [css] = useStyletron();
  const unique_data = new Set(data);
  return <div className={css({
    display: 'flex',
    flexFlow: 'row wrap',
    gap: '4px'
  })}>
      {[...unique_data.entries()].map(([data, val]) => {
      return <span key={val} className={css({
        background: COLOURS.lightGray,
        borderRadius: '4px',
        padding: '2px 4px'
      })}>
            {data}
          </span>;
    })}
    </div>;
};